'use client';

import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/src/models/search/product';
import { useEffect } from 'react';
import * as gtm from '../../../../../../lib/GTM';
import * as leanplum from '../../../../../../lib/leanplum';
import * as Targeting360 from '../../../../../../lib/targeting360';
import useSession from '../../../../../../stores/session/useSession';
import useFilters from './useFilters';

export default function useShopTracking(products: SearchProduct[]) {
  const { filters } = useFilters();
  const { user } = useSession();

  useEffect(() => {
    Targeting360.trackCategoryPage(
      filters.category && filters.category[0],
      filters.subcategory && filters.subcategory[0],
    );
  }, []);

  useEffect(() => {
    if (products.length === 0) {
      return;
    }
    gtm.impressions(products);
    gtm.viewCategory(
      filters.category && filters.category[0],
      filters.subcategory && filters.subcategory[0],
    );
    if (filters.category || filters.subcategory) {
      leanplum.recordEvent('list_view', {
        ...(filters.category && {
          category: filters.category[0],
        }),
        ...(filters.subcategory && {
          subcategory: filters.subcategory[0],
        }),
      });
    }
  }, [products]);
}
